import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { PriceFormatPipe } from '../../../pipes/price-format.pipe';
import { SpecialProductInterface } from '@interfaces/products/special_product_interface';
import { MenuActions } from '../../../states/menu_actions';

@Component({
  selector: 'ln-main-product-card',
  imports: [LnImageFrameComponent, PriceFormatPipe],
  templateUrl: './main-product-card.component.html',
  styleUrl: './main-product-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainProductCardComponent {
  @Input({ required: true }) product!: SpecialProductInterface;
  @Input({ required: false }) showPrice = true;
  private menuActions = inject(MenuActions);

  onClick() {
    this.menuActions.navigateToProductDetails(this.product.vendedorId, this.product.productoPrincipalId);
  }
}
